import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    getInvoiceHistoryOrderList,
    InvoiceHistoryOrderList,
    InvoiceHistoryOrderListParameter
} from "@tKgpco/Services/CustomInvoiceListOrderHistoryService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type OnSuccess = {
    onSuccess?: (result: InvoiceHistoryOrderList[]) => void | InvoiceHistoryOrderList[] | undefined;
};

type OnError = {
    onError?: (result: InvoiceHistoryOrderList[]) => void | string | undefined;
};

type ParameterParam = InvoiceHistoryOrderListParameter & OnSuccess & OnError;

type HandlerType = CustomApiHandler<ParameterParam, InvoiceHistoryOrderList[]>;

export const BeginInvoiceHistoryOrderList: HandlerType = props => {
    props.dispatch({ type: "Custom/InvoiceHistoryOrderList/BeginLoad" });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    
    try {
        props.apiResult = (await getInvoiceHistoryOrderList(props.apiParameter)) as unknown as InvoiceHistoryOrderList[];
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const CompleteInvoiceHistoryOrderList: HandlerType = props => {
    

    props.dispatch({
        type: "Custom/InvoiceHistoryOrderList/CompleteLoad",
        invoiceList: props.apiResult,
    });
};

export const chain = [BeginInvoiceHistoryOrderList, PopulateApiParameter, RequestDataFromApi, CompleteInvoiceHistoryOrderList];

const getInvoiceHistoryOrderListHandler = createHandlerChainRunner(chain, "GetInvoiceHistoryOrderList");
export default getInvoiceHistoryOrderListHandler;